// WithdrawCancelled.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function WithdrawCancelled() {
  const [withdraws, setWithdraws] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchCancelledWithdraws();
  }, []);

  const fetchCancelledWithdraws = async () => {
    try {
      const res = await axios.get(
        "https://api.earnmoney0.top/admin/withdraw-cancelled"
      );
      if (res.data.success) {
        setWithdraws(res.data.withdraws || []);
        setFiltered(res.data.withdraws || []);
      }
    } catch (err) {
      console.error("❌ Fetch Withdraw Cancelled Error:", err);
    }
  };

  // Filter Logic
  useEffect(() => {
    let data = [...withdraws];

    if (search.trim()) {
      data = data.filter(
        (d) =>
          d.userId?.username?.toLowerCase().includes(search.toLowerCase()) ||
          d.userId?.email?.toLowerCase().includes(search.toLowerCase()) ||
          d.number?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (startDate) data = data.filter((d) => new Date(d.createdAt) >= new Date(startDate));
    if (endDate) data = data.filter((d) => new Date(d.createdAt) <= new Date(endDate));

    setFiltered(data);
  }, [search, startDate, endDate, withdraws]);

  // Export CSV
  const exportCSV = () => {
    if (!filtered.length) {
      alert("⚠️ No data to export!");
      return;
    }

    const headers = "No,Username,Email,Method,Amount,Status,Number,Date\n";
    const rows = filtered.map((d, i) => {
      const date = new Date(d.createdAt).toLocaleString("en-GB");
      return `${i+1},${d.userId?.name || "Unknown"},${d.userId?.email || "N/A"},${d.method},${d.amount},${d.status},${d.number},${date}`;
    });

    const blob = new Blob([headers + rows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Withdraw_Cancelled_${new Date().toISOString().slice(0,10)}.csv`;
    link.click();
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>❌ Withdraw Cancelled History</h1>
        <button style={styles.exportBtn} onClick={exportCSV}>⬇️ Export CSV</button>
      </div>

      {/* Filters */}
      <div style={styles.filter}>
        <input
          type="text"
          placeholder="🔍 Search username, email, or Number..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={styles.searchInput}
        />
        <div style={styles.dateFilter}>
          <label style={styles.dateLabel}>From:</label>
          <input type="date" value={startDate} onChange={(e)=>setStartDate(e.target.value)} style={styles.dateInput} />
          <label style={styles.dateLabel}>To:</label>
          <input type="date" value={endDate} onChange={(e)=>setEndDate(e.target.value)} style={styles.dateInput} />
        </div>
      </div>

      {/* Table */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead style={styles.thead}>
            <tr>
              <th style={styles.th}>#</th>
              <th style={styles.th}>User</th>
              <th style={styles.th}>Method</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Number</th>
              <th style={styles.th}>Date</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="7" style={styles.noData}>No cancelled withdraws found</td>
              </tr>
            ) : (
              filtered.map((d, i) => (
                <tr key={d._id} style={styles.row}>
                  <td style={styles.td}>{i+1}</td>
                  <td style={styles.td}>{d.userId?.name || "Unknown"}</td>
                  <td style={styles.td}>{d.method}</td>
                  <td style={{...styles.td, color:"#22c55e"}}>৳{d.amount}</td>
                  <td style={{...styles.td, color:"#ef4444"}}>{d.status}</td>
                  <td style={{...styles.td, color:"#00eaff"}}>{d.number}</td>
                  <td style={styles.td}>{new Date(d.createdAt).toLocaleString("en-GB")}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ===================== CSS ===================== */
const styles = {
  page: { minHeight:"100vh", backgroundColor:"#0b0f1a", color:"#fff", padding:"20px" },
  header: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px", flexWrap:"wrap", gap:"15px" },
  title: { fontSize:"28px", fontWeight:"700" },
  exportBtn: { background:"#22c55e", border:"none", padding:"10px 20px", borderRadius:"8px", fontWeight:"700", cursor:"pointer" },
  filter: { display:"flex", flexWrap:"wrap", gap:"10px", marginBottom:"20px", alignItems:"center" },
  searchInput: { padding:"10px", borderRadius:"8px", border:"1px solid #374151", background:"#111827", color:"#fff", outline:"none", flex:"1" },
  dateFilter: { display:"flex", gap:"8px", alignItems:"center" },
  dateLabel: { color:"#9ca3af", fontWeight:"600" },
  dateInput: { padding:"6px 10px", borderRadius:"8px", border:"1px solid #374151", background:"#111827", color:"#fff", outline:"none" },
  tableWrapper: { overflowX:"auto", border:"1px solid #1e293b", borderRadius:"10px" },
  table: { width:"100%", borderCollapse:"collapse", textAlign:"left" },
  thead: { background:"#111827", color:"#facc15", textTransform:"uppercase" },
  th: { padding:"12px", borderBottom:"1px solid #374151" },
  td: { padding:"10px", borderBottom:"1px solid #374151" },
  row: { transition:"0.3s", hover:{background:"#1b2138"} },
  noData: { textAlign:"center", padding:"20px", color:"#9ca3af", fontStyle:"italic" }
};